import type { FaireProductEntity } from "../../entity_types/product";

export const p_9w8paht8r3: FaireProductEntity = {
  token: "p_9w8paht8r3",
  type: "product",
  name: "Full Time Lesbian Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/28a4b5f0dd26068e830c5576b160ecccd25cc36c64a1a1bc92fe33f989415a9d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c405e48ac131989fe06ea5d11874c0d006365b68c84429bbdb445d6a8a3fe133.jpeg",
    "https://cdn.faire.com/fastly/d22c48d1a250218aa7c9d286df8a79d9c199adf24eac18a3e1390c5e80b949c9.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/8cee66ab43fa6f9836d8a15ea49a99d1d7ddde59ca97b866f026d4f03daafd36.jpeg",
    "https://cdn.faire.com/fastly/8fad85bb686ddae47d5f82203816d764c05e46c0fa58efc3924c57a3856ae522.jpeg"
  ],
  priceDollars: 6.75,
  description: "This one's for the gold star lesbians - however you got here, you stuck the landing. Celebrate with some members-only socks!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:07.807Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
